import script from "./RevenuStatistic.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenuStatistic.vue?vue&type=script&setup=true&lang=js"

import "./RevenuStatistic.vue?vue&type=style&index=0&id=75c30be1&lang=css"

const __exports__ = script;

export default __exports__